
var initSortable = function() {
  $('#course_faqs .display-table__body').sortable({
    items: '.js-sortRow',
    handle: '.js-sortHandle',
    helper: function(e, ui) {
      ui.children().each(function() {
        $(this).width($(this).width());
      });
      return ui;
    },
    update: function(e, ui) {
      var self = this;
      $.ajax({
        url: $(this).parent().attr('data-update-url'),
        type: 'POST',
        data: $(this).sortable('serialize'),
        beforeSend: function(xhr, settings) {
          Kadenze.UIUtil.showLoadingIndicator($(self));
        },
        success: function(data, textStatus, xhr) {
          var $trs = $(self).children('.js-sortRow');
          $trs.each(function() {
            var $tr = $(this);
            var newVal = ($tr.index() + 1);
            $tr.find('.in-table__order-num').html(newVal);
          });
        },
        error: function(xhr, textStatus, errorThrown) {
          $('#course_faqs .display-table__body').sortable('cancel');
          Kadenze.UIUtil.showNotice($('.in-session-list'),{message: 'An unexpected error occurred. Please try again later.'}, 3000);
        },
        complete: function(xhr, textStatus) {
          Kadenze.UIUtil.hideLoadingIndicator($(self));
        }
      });
    }
  });
};

export default {
  init : function(element) {
    initSortable();
  }
};

